import Register from "../views/auth/Register";
import Login from "../views/auth/Login";
import Privacy from "../views/static/Privacy";
import NotFound from "../views/static/NotFound";
import ForgotPassword from "../views/auth/ForgotPassword";
import ResetPassword from "../views/auth/ResetPassword";

const web = [
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: {
      guest: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/register",
    component: Register,
    name: "register",
    meta: {
      guest: true,
    },
  },
  {
    path: "/privacy-policy",
    component: Privacy,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgotPassword",
    meta: {
      guest: true,
    },
  },
  {
    path: "/reset-password/:token",
    component: ResetPassword,
    name: "resetPassword",
    meta: {
      guest: true,
    },
  },
  {
    path: "*",
    component: NotFound,
  },
];
export default web;
